import { render, staticRenderFns } from "./GenderField.vue?vue&type=template&id=f8214338&"
import script from "./GenderField.vue?vue&type=script&lang=js&"
export * from "./GenderField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports